import React from "react";
import { Auth } from "aws-amplify";

import Card from "@material-ui/core/Card";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./style.css";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { isEqual } from "lodash";
import { saveLogin } from "./utils";

function ResetPasswordForm(props) {
  const [verificationCode, setVerification] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonStatus, setbuttonStatus] = useState(false);
  const history = useHistory();
  const handleConfirmVerification = (e) => {
    e.preventDefault();
    console.log("calling reset");
    setErrorMessage("");
    console.log(props.email);

    const trimmedCode = verificationCode.replace(/\s/g, ''); // Remove all spaces
    if (!/^\d{6}$/.test(trimmedCode)) {
      setErrorMessage("Please enter a valid 6-digit verification code");
      return;
    }

    console.log(verificationCode);
    console.log(password);
    if(props.addonSelfEnrollment){
      const generatedPassword = generatePassword(props.responseData.userAttributes);
      props.toggleLoader(true);
      Auth.forgotPasswordSubmit(props.email, trimmedCode, generatedPassword)
        .then((data) => {
          saveLogin(props.email, "handleSubmit");
          signInUser(generatedPassword);

        })
        .catch((err) => {
          props.toggleLoader(false);
          console.log(err.message);
          setErrorMessage(err.message);
        });
    }
    else if (isEqual(password, confirmPassword)) {
      props.toggleLoader(true);
      Auth.forgotPasswordSubmit(props.email, trimmedCode, password)
        .then((data) => {
          props.toggleLoader(false);
          console.log("password reset success");
          console.log(data);
          props.handlePassword(password);
          history.push(`/login?username=${props.email}&password=${password}`); 
          window.location.reload();
        })
        .catch((err) => {
          props.toggleLoader(false);
          console.log(err.message);
          setErrorMessage(err.message);
        });
    } else {
      setErrorMessage("Please enter same password");
      setbuttonStatus(true);
    }
  };

  const signInUser = async (generatedPassword) => {
      const authUser = await Auth.signIn({
          username: props.email,
          password: generatedPassword,
        }).catch((err) => {
          setErrorMessage("Incorrect username or password.");
          props.toggleLoader(false);
        });
          if (authUser) {
              props.toggleLoader(false);
              window.location.replace("/");
            }
  }

    const generatePassword = (userAttrs) => {
        const getValue = (key) => {
          const found = userAttrs.find(function (item) {
            return item.name === key;
          });
          return (found && found.value) || "";
        };
      const givenName = getValue("given_name");
      const familyName = getValue("family_name");
      const email = getValue("email");
      const phone = getValue("phone_number");
      const baseString = `${givenName}${familyName}${email || phone}`;

      let hash = 0;
      for (let i = 0; i < baseString.length; i++) {
        hash = (hash << 5) - hash + baseString.charCodeAt(i);
        hash |= 0;
      }
      const hashStr = Math.abs(hash).toString(36);
      const password = `${givenName.slice(0,2).charAt(0).toUpperCase()}${givenName.slice(1,2).toLowerCase()}${familyName.slice(0,2)}@${hashStr}12#`;

      return password;
    }



  const handleChange = (e) => {
    // console.log(e.target.value)
    // console.log(e.target.name)
    setErrorMessage("");
    if (e.target.name == "verificationCode") {
      setVerification(e.target.value.trim());
    } else if (e.target.name == "password") {
      setPassword(e.target.value.trim());
    } else if (e.target.name == "confirmPassword") {
      setConfirmPassword(e.target.value.trim());
    }
    // if(password==confirmPassword){
    //   setbuttonStatus(false)
    // }
    // else{
    //   console.log(password)
    //   console.log(confirmPassword)
    // }
  };

  return (
    <div className="login">
      <CssBaseline />
      <Container maxWidth="xs">
        <Card className="login-card" style={{ marginTop: "50px" }}>
          <div className="logo">
            <img
              alt="logo"
              className="logo-custom"
              src={require("./images/netwell-logo.png")}
            />
          </div>
          <form className="main-form">
            {!!!props.addonSelfEnrollment ?<p>
              We have sent a password reset code by email to {props.destination}
              . Enter it below to reset your password.
            </p> : 
            <div>
              We have sent a security code to {props.destination}.com. Enter the code here to sign-in.
            </div>}
            <div className="a-form-ctrl" style={{ marginTop: "20px" }}>
              <p className="">Code</p>
              <input
                className="a-input"
                type="text"
                name="verificationCode"
                required
                onChange={handleChange}
              />
            </div>
           {!!!props.addonSelfEnrollment && <div className="a-form-ctrl">
              <p className="">New Password</p>
              <input
                className="a-input"
                type="password"
                name="password"
                required
                onChange={handleChange}
              />
            </div>}
           {!!!props.addonSelfEnrollment &&  <div className="a-form-ctrl">
              <p className="">Enter New Password Again</p>
              <input
                className="a-input"
                type="password"
                name="confirmPassword"
                required
                onChange={handleChange}
              />
            </div>}
            <p
              className="a-errorMessage"
              hidden={errorMessage.length <= 0}
              style={{ marginTop: "10px" }}
            >
              {errorMessage}
            </p>

             <div>
              <button
                type="submit"
                className="a-btn"
                onClick={handleConfirmVerification}
                style={{ color: "#ffffff", backgroundColor: "#4782c4" }}
              >
                {!!!props.addonSelfEnrollment ? <span>Change password</span> : <span>Verify</span>}
              </button>
             {!!!props.addonSelfEnrollment ? <p style={{ textAlign: "center" }}>
                <span>Go back to</span>&nbsp;
                <span
                  className="forgot-pawd"
                  onClick={() => props.gotoLoginScreen()}
                >
                  Sign In
                </span>
              </p> : <div></div>}
            </div>
          </form>
        </Card>
      </Container>
    </div>

    // {/* <form onSubmit={props.handleSubmit}>
    //         <div className="container">
    //           <h1>reset password</h1>
    //           <p>Please fill in this form to login.</p>
    //           <hr />
    //           <label >
    //             <b>verificationCode</b>
    //           </label>
    //           <input
    //             type="text"
    //             placeholder="Enter verificationCode"
    //             name="verificationCode"
    //             required
    //             onChange={props.handleChange}
    //           />
    //     <br/>
    //     <label >
    //                     <b>new Password</b>
    //                   </label>
    //                   <input
    //                     type="password"
    //                     placeholder="Enter new Password"
    //                     name="password"
    //                     required
    //                     onChange={props.handleChange}
    //                   />
    //           <div className="clearfix">

    //             <button type="submit" className="signupbtn" onClick={props.handleConfirmVerification}>
    //               send verification code
    //             </button>
    //           </div>
    //         </div>
    //       </form> */}
  );
}

export default ResetPasswordForm;
